// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__Olb8L","rootSmall":"AddTileButton_rootSmall__18Q_S"};